import * as Constants from '../constants';

const initialState = {};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.CREATE_ORDER_START:
      return Object.assign({}, state, { data: state.data, action, loading: true });
    case Constants.CREATE_ORDER_SUCCESS:
      return Object.assign({}, state, { data: action.data, action, loading: false });
    case Constants.CREATE_ORDER_FAILURE:
      return Object.assign({}, state, { data: action.data, action, loading: false });
    default:
      return { ...state };
  }
}
